'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import OrgsController from './controller/orgs';
import OrgModalCreateController from './controller/orgModalCreate';
import OrgModalSelectController from './controller/orgModalSelect';
import OrgFilterController from './controller/orgFilter';
import OrgTableDirective from './directive/orgTable';
import OrgSelectDirective from './directive/orgSelect';
import OrgTableRowDirective from './directive/orgTableRow';
import OrgOkvedTableDirective from './directive/orgOkvedTable';
import OrgCheckInn from './directive/orgCheckInn';
import OrgService from './service/org';

export default angular.module('investmentProject.org', [])
                      .controller('OrgsController', OrgsController)
                      .controller('OrgModalCreateController', OrgModalCreateController)
                      .controller('OrgModalSelectController', OrgModalSelectController)
                      .controller('OrgFilterController', OrgFilterController)
                      .directive('orgTable', OrgTableDirective)
                      .directive('orgOkvedTable', OrgOkvedTableDirective)
                      .directive('orgSelect', OrgSelectDirective)
                      .directive('orgTableRow', OrgTableRowDirective)
                      .directive('orgCheckInn', OrgCheckInn)
                      .factory('OrgService', OrgService)
    .name;
